'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _IssuePage = require('./IssuePage.css');

var _IssuePage2 = _interopRequireDefault(_IssuePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IssueFossilFuels = (_dec = (0, _reactCssModules2.default)(_IssuePage2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IssueFossilFuels, _Component);

  function IssueFossilFuels(props) {
    (0, _classCallCheck3.default)(this, IssueFossilFuels);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IssueFossilFuels.__proto__ || (0, _getPrototypeOf2.default)(IssueFossilFuels)).call(this, props));

    _this.state = {
      title: 'The issue: Fossil fuels',
      description: 'Coal, oil, and gas release carbon pollution that accelerates the climate emergency. Rising temperatures will continue to exacerbate the impacts of fires, floods, deadly heatwaves, and other environmental disasters.',
      url: _config2.default.domain + _config2.default.routes.issueFossilFuels
    };
    return _this;
  }

  (0, _createClass3.default)(IssueFossilFuels, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page issue-fff' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              'h1',
              { styleName: 'issue-top-label' },
              'The issue: ',
              _react2.default.createElement(
                'span',
                null,
                'Fossil fuels'
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'issue-top-headline' },
              'Asset managers are investing in the climate crisis'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'issue-top-copy' },
              'Coal, oil, and gas release carbon pollution that accelerates the climate emergency. Rising temperatures will continue to exacerbate the impacts of fires, floods, deadly heatwaves, and other environmental disasters.'
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-headline' },
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap' } },
                    '\u2014\u2014\u2014\u2014'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Retirement plans are still heavily invested in coal, oil, and gas'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-copy' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'As the financial industry looks to align their businesses with the ',
                    _react2.default.createElement(
                      _components.Link,
                      { to: 'https://unfccc.int/process-and-meetings/the-paris-agreement/the-paris-agreement', title: 'The Paris Agreement - United Nations: Climate Change', xstrong: true },
                      'Paris climate agreement,'
                    ),
                    ' asset managers are beginning to exclude some of the most egregious climate offenders, like thermal coal producers, from the funds they offer in corporate retirement plans. However, 401(k)s and similar retirement plans are still mostly invested in index funds with broad exposure to fossil fuel companies \u2013 from Big Oil to small fracking companies.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Asset managers like Vanguard are investing in a deadly industry \u2013 and they\u2019re using workers\u2019 retirement plan savings to do so. Through funds from asset managers like Vanguard, BlackRock, and State Street, the retirement plans of companies like Amazon and Comcast are investing hundreds of billions of dollars into fossil fuel companies that are fueling the climate crisis.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement('div', { styleName: 'img-issue' })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'issue-focus-label' },
                    'FOCUS: SUSTAINABILITY RISK'
                  ),
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'issue-focus-headline' },
                    'Top carbon reserve owners'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Oil majors and coal mining companies continue to explore for new fossil fuel deposits, despite knowing full well we can only burn a fraction of current proven reserves and still avoid catastrophic climate change.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'As governments act to restrict emissions, these carbon reserves may become stranded assets, sinking companies and taking people\u2019s savings down with them.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.companies + '#fossilfuels',
                          title: 'Companies: Fossil fuels',
                          xstrong: true
                        },
                        'Learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'section-solutions-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section section-solutions-faq' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-solutions-label' },
                      'The Solutions'
                    ),
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'issue-solutions-headline' },
                      'Exclude climate-harming companies from retirement plan default options'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-copy' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'The default option offered in company retirement plans, which usually ends up with the bulk of employee contributions, should be sustainably invested and exclude major climate offenders like the ',
                        _react2.default.createElement(
                          _components.Link,
                          { to: 'https://www.ffisolutions.com/research-analytics-index-solutions/research-screening/the-carbon-underground-200/', title: 'The Carbon Underground 200 - FFI Solutions', xstrong: true },
                          'Carbon Underground 200'
                        ),
                        ' and the ',
                        _react2.default.createElement(
                          _components.Link,
                          { to: 'https://coalexit.org/', title: 'Global Coal Exit List 2020 - Urgewald', xstrong: true },
                          'Global Coal Exit List.'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.solutionDefaultSustainability,
                          title: 'Solution: Default to sustainability',
                          xstrong: true
                        },
                        'Explore solutions',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-faqs-label' },
                      'FAQs'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-headline' },
                      'Answers to common questions about how retirement plans and asset managers are financing the climate crisis.'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-',
                          title: 'Do I have to sacrifice returns in order to invest sustainably?',
                          xstrong: true
                        },
                        'Do I have to sacrifice returns in order to invest sustainably?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-',
                          title: 'Why should retirement plans add a sustainable investment option?',
                          xstrong: true
                        },
                        'Why should retirement plans add a sustainable investment option?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs,
                          title: 'FAQs',
                          xstrong: true
                        },
                        'View all >>'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return IssueFossilFuels;
}(_react.Component)) || _class);
exports.default = IssueFossilFuels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/IssuePage/IssueFossilFuels.js
// module id = 1484
// module chunks = 0